import { render, staticRenderFns } from "./DropdownCollapse.vue?vue&type=template&id=2dbae12c"
import script from "./DropdownCollapse.vue?vue&type=script&lang=js"
export * from "./DropdownCollapse.vue?vue&type=script&lang=js"
import style0 from "./DropdownCollapse.vue?vue&type=style&index=0&id=2dbae12c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports